/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Filters = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 22 20" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g><path d="M16 14a3 3 0 0 0-2.82 2H0v2h13.18a3 3 0 0 0 5.64 0H22v-2h-3.18A3 3 0 0 0 16 14zm0 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2zM6 7a3 3 0 0 0-2.82 2H0v2h3.18a3 3 0 0 0 5.64 0H22V9H8.82A3 3 0 0 0 6 7zm0 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2zM18.82 2a3 3 0 0 0-5.64 0H0v2h13.18a3 3 0 0 0 5.64 0H22V2zM16 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" /></g>
      </g>
    </svg>
  </span>
);

Filters.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Filters.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Filters;
